import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';

import { LoadPanel } from 'devextreme-react/load-panel';
import { Toast } from 'devextreme-react/toast';

import { confirm } from 'devextreme/ui/dialog';

import Form, { Item, GroupItem, Label, RequiredRule } from 'devextreme-react/form';

import { Link, useHistory } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRotateLeft } from '@fortawesome/pro-solid-svg-icons';
import { faSave } from '@fortawesome/pro-solid-svg-icons';
import { faBox } from '@fortawesome/pro-duotone-svg-icons';

import { callProcesa } from '../api/callProcesa';

import './Clusters.css';

export default function ClustersForm(props) {
  const permissionLevel = props.nivel;
  const clusterId = props.clusterId;
  const isNew = !clusterId || clusterId === 'undefined';

  const history = useHistory();

  const [clusterPayload, setClusterPayload] = useState({});
  const [clusterType, setClusterType] = useState([]);
  const [activateSaveButton, setActivateSaveButton] = useState(false);
  const [activateUpdateForm, setActivateUpdateForm] = useState(false);

  const [visibleLoadPanel, setVisibleLoadPanel] = useState(false);

  const [visibleToast, setVisibleToast] = useState(false);
  const [messageToast, setMessageToast] = useState('');
  const [typeToast, setTypeToast] = useState('success');

  const formDatosGeneralesRef = useRef(null);

  const internalidEditorOptions = useMemo(() => {
    return { width: '100%', readOnly: true, visible: false };
  }, []);

  const clusterNameEditorOptions = useMemo(() => {
    return { width: '100%', inputAttr: { 'style': 'text-transform: uppercase' } };
  }, []);

  const capacityEditorOptions = useMemo(() => {
    return { width: '100%', visible: true, format: '#,##0' };
  }, []);

  const descriptionEditorOptions = useMemo(() => {
    return { width: '100%', visible: true, inputAttr: { 'style': 'text-transform: uppercase' } };
  }, []);

  //Opciones Tipo de Cluster
  const tipoClusterEditorOptions = useMemo(() => {
    return {
      dataSource: clusterType,
      displayExpr: 'name',
      valueExpr: 'value',
      searchEnabled: true,
      value: (clusterPayload.custrecord_al_por_clu_type ? clusterPayload.custrecord_al_por_clu_type : ''), width: '100%'
    };
  }, [clusterType, clusterPayload.custrecord_al_por_clu_type]);

  const toastPosition = useMemo(() => {
    return { my: 'top center', at: 'top center', of: window, offset: '0 130' };
  }, []);

  // Carga el lookup de tipos de cluster (dropdown del formulario).
  const getClusterTypeList = useCallback(async () => {
    const datos = await callProcesa('/procesahelper', { action: 'clusterTypeList' });
    setClusterType(datos.data);
  }, []);

  // Carga el payload según el id de la ruta (o inicializa nuevo).
  useEffect(() => {
    async function initialize() {
      setVisibleLoadPanel(true);
      try {
        await getClusterTypeList();

        if (isNew) {
          setClusterPayload({});
        } else {
          const datos = await callProcesa('/procesacluster', {
            action: 'payload',
            internalid: clusterId,
            name: undefined,
          });
          setClusterPayload(datos.data);
        }

        const canEdit = permissionLevel === 'Editar';
        setActivateUpdateForm(canEdit);
        setActivateSaveButton(canEdit);
      } catch (e) {
        if (e === 'No current user') {
          history.push('/');
          window.location.reload();
        }
      } finally {
        setVisibleLoadPanel(false);
      }
    }

    initialize();
  }, [clusterId, isNew, permissionLevel, history, getClusterTypeList]);

  const onFieldDataChanged = useCallback((e) => {
  }, []);

  const saveButton = useCallback(async () => {
    const locationName = clusterPayload.name;
    const internalid = clusterPayload.internalid;

    if (formDatosGeneralesRef.current) {
      const formInstance = formDatosGeneralesRef.current.instance();
      const isValid = formInstance.validate();

      if (!isValid.isValid) {
        setVisibleToast(true);
        setMessageToast(isValid.brokenRules[0].message);
        setTypeToast('error');
        return;
      }
    }

    const result = confirm("<i>La creación o actualización de clusters actualizará miles de registros en Netsuite y solo debe realizarse por las mañanas. ¿Desea continuar?</i>", "Actualización de Clusters");

    result.then(async (dialogResult) => {
      if (dialogResult) {
        try {
          setVisibleLoadPanel(true);

          const payloadPost = await callProcesa('/procesacluster', {
            locationName: locationName,
            internalid: internalid,
            action: 'postData',
            data: clusterPayload,
          });

          if (payloadPost.success) {
            if (!internalid) {
              setVisibleToast(true);
              setMessageToast('Se creó el Cluster con éxito');
              setTypeToast('success');

              const newID = payloadPost.data.id;

              // Navega al nuevo id: el contenedor re-monta el Form (key) y recarga.
              history.push('/Clusters/' + newID.toString());
            } else {
              setVisibleToast(true);
              setMessageToast('Se actualizó el Cluster con éxito');
              setTypeToast('success');

              // Refresca el payload con lo que devuelve NetSuite.
              const fresh = await callProcesa('/procesacluster', {
                action: 'payload',
                internalid: internalid,
                name: undefined,
              });
              setClusterPayload(fresh.data);
            }
          } else if (!payloadPost.success) {
            setVisibleToast(true);
            setMessageToast(payloadPost.message);
            setTypeToast('error');
          }

          setVisibleLoadPanel(false);
        } catch (e) {
          setVisibleLoadPanel(false);

          if (e === 'No current user') {
            history.push('/');
            window.location.reload();
          }
        }
      }
    });
  }, [history, clusterPayload]);

  const onHidingToast = useCallback(() => {
    setVisibleToast(false);
  }, []);

  return (
    <div>
      <div class="bg-gray-200 m-2">
        <h1 class="font-sans inline-block text-xl font-bold text-gray-700 leading-8 align-top mb-1 pl-3"><FontAwesomeIcon icon={faBox} size="xl" /> {clusterPayload.name}</h1>
      </div>

      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        visible={visibleLoadPanel}
        showIndicator={true}
        message="Por favor espere..."
        shading={true}
        showPane={true}
        hideOnOutsideClick={false}
      />

      <Toast
        visible={visibleToast}
        message={messageToast}
        type={typeToast}
        onHiding={onHidingToast}
        displayTime={5000}
        width={'auto'}
        position={toastPosition}
      />

      <div class="m-3 bg-gray-200">
        <Link to="/Clusters">
          <button type="submit" class="mb-4 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
            <FontAwesomeIcon icon={faArrowRotateLeft} /> Regresar
          </button>
        </Link>

        {activateSaveButton ? (
          <button onClick={saveButton} type="submit" class="ml-4 mb-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            <FontAwesomeIcon icon={faSave} /> Guardar Cambios
          </button>
        ) : (
          <div class="inline-block"></div>
        )}

        <div class="mt-1 bg-white pt-3 shadow-xl">
          <div class="ml-4 mr-4 bg-white pt-3">
            <Form id="datosGenerales"
              labelMode={'outside'}
              formData={clusterPayload}
              readOnly={!activateUpdateForm}
              showColonAfterLabel={false}
              labelLocation={'left'}
              colCount={2}
              onFieldDataChanged={onFieldDataChanged}
              ref={formDatosGeneralesRef}
            >
              <GroupItem caption="Datos Generales">
                <Item cssClass="boldText" dataField="internalid" editorOptions={internalidEditorOptions} >
                  <Label text="" visible={false} />
                </Item>
                <Item cssClass="boldText" dataField="name" editorOptions={clusterNameEditorOptions} >
                  <Label text={"Nombre"} />
                  <RequiredRule message="Nombre es requerido" />
                </Item>
                <Item dataField="custrecord_al_por_clu_type" editorType="dxSelectBox" editorOptions={tipoClusterEditorOptions} >
                  <Label text="Tipo de Cluster" />
                  <RequiredRule message="Tipo de Cluster es requerido" />
                </Item>
                <Item dataField="custrecord_al_por_clu_desc" editorType="dxTextArea" editorOptions={descriptionEditorOptions} >
                  <Label text="Descripción" />
                </Item>
                <Item dataField="custrecord_al_por_clu_capacity" editorType="dxNumberBox" editorOptions={capacityEditorOptions} >
                  <Label text="Capacidad" />
                </Item>
                <Item dataField="custrecord_al_por_clu_inactive" editorType="dxCheckBox" >
                  <Label text="Inactivo" />
                </Item>
              </GroupItem>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
